import { Navigate } from 'react-router-dom';
import settingsComponents from '../../../../../config/semantic-components/settings-intellio-v2.json';
import settingsRoutesConfig from '../../../../../config/semantic-routes/settings.json';
import { StaffSettingsSemanticPage } from '../../internal-owned/school-settings-v2/StaffSettingsSemanticPage';
import { getStaffSettingsSectionRoute, type StaffSettingsSection } from '../../settings/settingsEntrySystem';
import {
  SemanticRouteAdapter,
  type SemanticComponentsConfig,
  type SemanticRoutesConfig,
} from '../SemanticRouteAdapter';

const componentsConfig = settingsComponents as SemanticComponentsConfig;
const routesConfig = settingsRoutesConfig as SemanticRoutesConfig;

const resolveCanonicalPath = (componentId: string, params: Record<string, string | undefined>): string | null => {
  if (componentId === 'settings-general') return getStaffSettingsSectionRoute('general');
  if (componentId === 'settings-users') return getStaffSettingsSectionRoute('users');
  if (componentId === 'settings-admissions') return getStaffSettingsSectionRoute('admissions');
  if (componentId === 'settings-financial-aid') return getStaffSettingsSectionRoute('financial-aid');
  return null;
};

const mapCanonicalSettingsPath = (pathname: string | null): string | null => {
  if (!pathname) return pathname;
  const normalized = pathname.replace(/\/+$/, '') || '/';

  if (normalized === '/school/settings') {
    return '/admin/settings/staff/general';
  }

  if (normalized.startsWith('/school/settings/')) {
    const suffix = normalized.slice('/school/settings/'.length);
    if (suffix.startsWith('general')) return '/admin/settings/staff/general';
    if (suffix.startsWith('users')) return '/admin/settings/staff/users';
    if (suffix.startsWith('admissions')) return '/admin/settings/staff/admissions';
    if (suffix.startsWith('financialaid')) return '/admin/settings/staff/financial-aid';
    if (suffix.startsWith('financial-aid')) return '/admin/settings/staff/financial-aid';
  }

  return pathname;
};

const sectionFromPathname = (pathname: string): StaffSettingsSection => {
  const normalized = pathname.replace(/\/+$/, '');
  if (normalized.endsWith('/users')) return 'users';
  if (normalized.endsWith('/admissions')) return 'admissions';
  if (normalized.endsWith('/financialaid') || normalized.endsWith('/financial-aid')) return 'financial-aid';
  return 'general';
};

export function SettingsSemanticRoute() {
  return (
    <div data-extracted-from="owned:ystnj/semantic/settings-route">
      <SemanticRouteAdapter
        moduleKey="settings"
        componentsConfig={componentsConfig}
        routesConfig={routesConfig}
        mapIntegrationPath={mapCanonicalSettingsPath}
        strictNoFallback
        blockBridgedTarget
        internal={{
          resolvePath: (componentId) => resolveCanonicalPath(componentId, {}),
          render: ({ internalPath, pathname }) => {
            if (pathname !== internalPath) {
              return <Navigate to={internalPath} replace />;
            }
            return (
              <StaffSettingsSemanticPage
                section={sectionFromPathname(pathname)}
              />
            );
          },
        }}
      />
    </div>
  );
}
